import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {UserNotification} from '@/features/notifications/types'
import {useNotificationDescription} from '@/features/notifications/hooks/useNotificationDescription'
import {useTranslation} from '@/translations/i18n'

/**
 * One notification in the home card. It reads its parts from the shared
 * `useNotificationDescription` so the card names things exactly like the notifications panel —
 * hence a component of its own, since the hook cannot run inside a map.
 */
export const HomeNotificationRow = ({notification}: {notification: UserNotification}) => {
    const {t} = useTranslation()
    const {title, subtitle, conversationKind} = useNotificationDescription(notification)

    // An internal conversation has no patient to name, so it says so instead of
    // leaving the detail line empty.
    const detail =
        conversationKind === 'internal' ? (
            <Text size="textXs" palette="neutral" shade="700">
                {t('conversations:kind_internal')}
            </Text>
        ) : (
            subtitle && (
                <Text size="textXs" palette="neutral" shade="700">
                    {subtitle.patientName && <span>{subtitle.patientName}</span>}
                    {subtitle.projectCode && <span> • PRI n°{subtitle.projectCode}</span>}
                    {subtitle.repeatedAgendaDetail && <span> • {subtitle.repeatedAgendaDetail}</span>}
                </Text>
            )
        )

    return (
        <Flexbox align="center" gap={3}>
            <Flexbox align="center" gap={1}>
                <Text size="textLg" weight="500" palette="neutral" shade="900">
                    •
                </Text>
                <Text size="textMd" weight="500" palette="neutral" shade="900">
                    {title}
                </Text>
            </Flexbox>
            {detail}
        </Flexbox>
    )
}
